import useProjectDomains from "../../../../api/utilities/useProjectDomains.js";
import Spinner from "../../../../components/Spinner.jsx";
import {useTranslation} from "react-i18next";
import Button from "../../../../components/Button.jsx";
import Creatable from "react-select/creatable";
import {useEffect, useMemo, useState} from "react";
import LoadingComponent from "../../../../components/LoadingComponent.jsx";
import {ProjectApi} from "../../../../api/authority/generated/index";
import useAuthorityConfiguration from "../../../../api/utilities/useAuthorityConfiguration.js";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrashCan} from "@fortawesome/free-regular-svg-icons";
import {useSupportedCurrencies, useSupportedCurrency} from "../../../../api/utilities/useSupportedCurrencies.js";
import Select from "react-select";

export default function HostNameAndTldAndCurrencyCodeAndApiKeyList({
                                                                       project,
                                                                       projectIntegration,
                                                                       value,
                                                                       onChange,
                                                                       apiKeySameForAll
                                                                   }) {
    let {t} = useTranslation();
    let authorityConfiguration = useAuthorityConfiguration();

    apiKeySameForAll = apiKeySameForAll ?? false;

    let projectDomains = useProjectDomains(project);
    let [projectDomainNameWithTldAndApiKeyList, setProjectDomainNameWithTldAndApiKeyList] = useState(null);

    let supportedCurrencies = useSupportedCurrencies();
    let supportedCurrency = useSupportedCurrency();

    useEffect(() => {
        if (projectIntegration === null) {
            setProjectDomainNameWithTldAndApiKeyList([]);
            return;
        }

        new ProjectApi(authorityConfiguration)
            .hostNameAndTLDAndApiKey({
                integrationId: projectIntegration.id
            })
            .then(setProjectDomainNameWithTldAndApiKeyList)
            .catch(() => setProjectDomainNameWithTldAndApiKeyList([]));
    }, [project.id, projectIntegration?.id]);

    let hostNameOptions = useMemo(() => {
        if (projectDomains === null) {
            return [];
        }
        return projectDomains.map((projectDomain) => ({
            value: projectDomain.projectDomain.hostName,
            label: projectDomain.projectDomain.hostName
        }));
    }, [projectDomains]);

    useEffect(() => {
        onChange(projectDomainNameWithTldAndApiKeyList);
    }, [projectDomainNameWithTldAndApiKeyList]);

    return <LoadingComponent
        className={'border-1 p-3 border-slate-500 rounded'}
        loading={projectDomainNameWithTldAndApiKeyList === null}
    >
        {projectDomains === null && <Spinner/>}
        {projectDomains && <div>
            {(value ?? []).map((row, index) => {
                return [
                    <div className={'flex gap-2 pt-2'} key={'xml-link-row-1-' + index}>
                        <Creatable
                            value={{label: row.hostName, value: row.hostName}}
                            className={'w-8/12'}
                            onChange={(e) => {
                                value[index] = {...row, hostName: e.value};
                                onChange(value);
                            }}
                            options={hostNameOptions}
                        />
                        <Select
                            value={supportedCurrency(row.currencyCode)}
                            className={'w-4/12'}
                            onChange={(e) => {
                                value[index] = {...row, currencyCode: e.value};
                                onChange(value);
                            }}
                            options={supportedCurrencies}
                        />
                    </div>,
                    <div className={'flex gap-2 pt-2 border-b-1 pb-2 border-slate-500'} key={'xml-link-row-2-' + index}>
                        <div className={'w-2/12 form-input flex'}>
                            glami.<input
                            value={row.tld}
                            className={'form-input w-16 h-5 px-1'}
                            type={'text'}
                            onChange={(e) => {
                                value[index] = {...row, tld: e.target.value};
                                onChange(value);
                            }}
                        />
                        </div>
                        <input
                            value={row.apiKey}
                            className={'w-9/12 form-input'}
                            type={'text'}
                            onChange={(e) => {
                                for (let subIndex in value) {
                                    if (index.toString() === subIndex.toString() || apiKeySameForAll) {
                                        value[subIndex] = {...value[subIndex], apiKey: e.target.value};
                                    }
                                }

                                onChange(value);
                            }}
                        />
                        <Button
                            className={'button button-danger-outline w-1/12'}
                            onClick={() => {
                                onChange(value.filter((x, checkedIdx) => index !== checkedIdx));
                            }}
                        >
                            <FontAwesomeIcon icon={faTrashCan}/>
                        </Button>
                    </div>
                ];
            })}
        </div>}
        <div className={'pt-2'}>
            <Button
                className={'button button-success-outline'}
                onClick={() => {
                    onChange([...value, {hostName: '', tld: '', apiKey: ''}]);
                }}
            >
                {t('add-hostname-and-tld-and-api-key')}
            </Button>
        </div>
    </LoadingComponent>;
}